module.exports = __webpack_public_path__ + "img/Réalisation portail  avec ouverture sur l_extérieur.d6cdbed5.jpg";